var exports = {
  "v": "x127c5a35--dfe740--banner",
};

module.exports = exports;
